<template>
  <div :class="['upgrade_message', {'is_large': isLarge, 'is_centered': isCentered}]">
    <h4 :class="['upgrade_message--heading', {'is_large': isLarge, 'is_centered': isCentered}]">
      {{ heading ? heading : "Upgrade Required" }}
    </h4>

    <p :class="['upgrade_message--message', {'is_large': isLarge, 'is_centered': isCentered}]">
      Please <a @click="openBillingPortal">upgrade</a> your subscription to use this feature
    </p>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "AppUpgradeRequired",
  props: {
    heading: String,
    isLarge: {
      type: Boolean,
      default: false,
    },
    isCentered: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style scoped lang="scss">
@import "../../styles/variables/variables";

.upgrade_message {
  padding: 0.5rem 0;
  font-style: italic;

  &.is_centered {
    text-align: center;
  }

  &--heading {
    margin-bottom: 8px;
    font-weight: bold;

    &.is_large {
      font-size: 1.5rem;
    }
  }

  &--message {
    line-height: 1.2;

    &.is_large {
      font-size: 1.25rem;
    }
  }
}
</style>
